// Параметри тестів — змінюємо тут, якщо треба перебалансувати.
// questionCount: 'all' = всі питання категорії/помилок/закладок (без обмеження).
// timeLimitSeconds: 0 = без таймера; >0 = жорсткий ліміт (як на офіційному іспиті).
export const EXAM_CONFIG = {
  CATEGORY: { questionCount: 'all' as const, timeLimitSeconds: 0, passThreshold: 0.8 },
  OFFICIAL_20: { questionCount: 20, timeLimitSeconds: 1200, passThreshold: 0.9 }, // 18/20 — як у СЦ МВС, макс. 2 помилки
  RANDOM_20: { questionCount: 20, timeLimitSeconds: 0, passThreshold: 0.8 }, // тренувальний білет: 20 рандомних, без часу
  HARDEST_100: { questionCount: 100, timeLimitSeconds: 0, passThreshold: 0.8 }, // 100 найскладніших за статистикою
  MISTAKES: { questionCount: 'all' as const, timeLimitSeconds: 0, passThreshold: 0.8 },
  BOOKMARKS: { questionCount: 'all' as const, timeLimitSeconds: 0, passThreshold: 0.8 },
  MARATHON: { questionCount: 100, timeLimitSeconds: 3600, passThreshold: 0.8 },
} as const;

// Гейміфікація — нарахування XP
export const XP_REWARDS = {
  PER_CORRECT_ANSWER: 10,
  TEST_PASSED_BONUS: 50,
  PERFECT_SCORE_BONUS: 100,
} as const;

// Реферальний бонус (нараховується після першого зданого тесту реферала)
export const REFERRAL_BONUS_XP = 200;
